module.exports = __webpack_public_path__ + "img/file-acl.a03e5531.png";